import IReportOutput from "@/api/models/IReportOutput";

export default function createReportOutput(): IReportOutput {
  return {
    id: "",
    projectId: "",
    parentFolderId: "",
    title: "",
    startDate: "",
    endDate: ""
  };
}
